"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var hex_1 = require("../utils/hex");
var tools_1 = require("../utils/tools");
var colorReg = /^\s*(rgba\([^\)]+\)|rgb\([^\)]+\)|\#[\d|a-f]{3,6})|\w*/i;
var NAME = 'background';
function getBgAttrs(style) {
    var colorMatch = style.match(colorReg);
    if (!colorMatch)
        return;
    var background = hex_1.toRgba(colorMatch[0]);
    if (background) {
        return {
            color: background
        };
    }
    return false;
}
var Background = /** @class */ (function (_super) {
    __extends(Background, _super);
    function Background() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.tagName = function () { return 'span'; };
        _this.attrs = {
            color: {
                default: null
            }
        };
        _this.parseDOM = [
            {
                style: 'background',
                getAttrs: getBgAttrs
            },
            {
                style: 'background-color',
                getAttrs: getBgAttrs
            }
        ];
        _this.toDOM = function (node) { return ['span', { style: "background-color: " + node.attrs.color }, 0]; };
        return _this;
    }
    return Background;
}(core_utilities_1.Inline));
exports.Background = Background;
var BackgroundController = /** @class */ (function (_super) {
    __extends(BackgroundController, _super);
    function BackgroundController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'background';
        _this.defaultColor = 'rgba(0, 0, 0, 1)';
        _this.getAttrs = function (color) {
            var rgba = "rgba(" + color.r + ", " + color.g + ", " + color.b + ", " + color.a + ")";
            return {
                color: rgba
            };
        };
        _this.getValue = function (attrs) {
            return attrs.color;
        };
        _this.toolbar = {
            className: 'background',
            tooltip: 'background-color'
        };
        _this.disable = function (editor) {
            return tools_1.checkMarkDisable(editor.view, NAME);
        };
        return _this;
    }
    return BackgroundController;
}(core_utilities_1.SylController));
exports.BackgroundController = BackgroundController;
var BackgroundPlugin = /** @class */ (function (_super) {
    __extends(BackgroundPlugin, _super);
    function BackgroundPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = NAME;
        _this.Controller = BackgroundController;
        _this.Schema = Background;
        return _this;
    }
    return BackgroundPlugin;
}(core_utilities_1.SylPlugin));
exports.BackgroundPlugin = BackgroundPlugin;
//# sourceMappingURL=background.js.map